module.exports = __webpack_public_path__ + "static/media/Menu.e1f03867.png";